export const PERMISSION_LABELS_AR: Record<string, string> = {
  "content:create-draft": "إنشاء مسودة محتوى",
  "content:edit": "تعديل المحتوى",
  "content:delete-draft": "حذف مسودة",
  "content:submit": "إرسال للمراجعة",
  "content:review": "مراجعة المحتوى",
  "content:approve": "اعتماد المحتوى",
  "content:publish": "نشر المحتوى",
  "users:create": "إنشاء مستخدم",
  "users:read": "عرض المستخدمين",
  "users:update": "تحديث مستخدم",
  "users:deactivate": "تعطيل مستخدم",
  "users:assign-roles": "تعيين الأدوار",
  "users:manage-permissions": "إدارة الصلاحيات",
  "users:manage-editor-permissions": "إدارة صلاحيات المحررين",
  "documents:upload": "رفع مستندات",
  "documents:read": "قراءة المستندات",
  "documents:manage": "إدارة المستندات",
  "support:access": "الوصول إلى نظام التذاكر",
  // ⚠️ obs:manage HAD NO LABEL and was rendering in the panel as the raw key `obs:manage`,
  // under a group heading that was likewise the raw word `obs`. Added here alongside the FAQ
  // one rather than left inconsistent — the two toggles sit next to each other.
  "obs:manage": "إدارة تقارير الموازنة المفتوحة",
  "delegations:manage": "إدارة الإيفادات الرسمية",
  "faq:manage": "إدارة الأسئلة الشائعة",
  "system:view-dashboard": "عرض لوحة التحكم",
  "system:view-analytics": "عرض التحليلات",
  "system:manage-settings": "إدارة الإعدادات",
  "system:backup-restore": "النسخ الاحتياطي",
  "system:view-audit-logs": "سجل التدقيق",
  "security:manage-tokens": "إدارة الرموز الأمنية",
};

export const PERMISSION_GROUPS_AR: Record<string, string> = {
  content: "المحتوى",
  users: "المستخدمون",
  documents: "المستندات",
  system: "النظام",
  security: "الأمان",
  obs: "الموازنة المفتوحة",
  faq: "الأسئلة الشائعة",
  support: "الدعم",
};

export function getPermissionLabel(permission: string): string {
  return PERMISSION_LABELS_AR[permission] ?? permission;
}

export function getPermissionGroup(permission: string): string {
  const group = permission.split(":")[0] ?? "other";
  return PERMISSION_GROUPS_AR[group] ?? group;
}
